var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const TENANT_FEATURE_CONFIG_PATH = '/smartlook-tenants.json';
export const getRichMapTenantOptions = (tenantId, antiAliasTenants) => tenantId !== null &&
    tenantId !== undefined &&
    antiAliasTenants.has(String(tenantId))
    ? { antialias: true }
    : {};
let tenantFeatureConfigPromise = null;
const emptyTenantFeatureConfig = () => ({
    smartlookTenants: new Set(),
    antiAliasTenants: new Set(),
});
const isLocalDevelopment = () => typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1');
const toTenantSet = (tenants) => new Set((Array.isArray(tenants) ? tenants : []).map((tenant) => String(tenant)));
export const getTenantFeatureConfig = () => {
    if (!tenantFeatureConfigPromise) {
        if (isLocalDevelopment()) {
            tenantFeatureConfigPromise = Promise.resolve(emptyTenantFeatureConfig());
            return tenantFeatureConfigPromise;
        }
        tenantFeatureConfigPromise = fetch(TENANT_FEATURE_CONFIG_PATH, {
            cache: 'no-store',
        })
            .then((response) => __awaiter(void 0, void 0, void 0, function* () {
            if (!response.ok) {
                throw new Error(`Failed to load tenant feature config: ${response.status}`);
            }
            const payload = (yield response.json());
            return {
                smartlookTenants: toTenantSet(payload === null || payload === void 0 ? void 0 : payload.tenants),
                antiAliasTenants: toTenantSet(payload === null || payload === void 0 ? void 0 : payload.antiAliasTenants),
            };
        }))
            .catch((error) => {
            console.warn('Tenant feature config unavailable. Skipping tenant-specific features.', error);
            return emptyTenantFeatureConfig();
        });
    }
    return tenantFeatureConfigPromise;
};
